import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';

import styles from './styles.module.css';

const Selections = ({answers, questions, hostRef}) => (
    <ul className={styles.list} ref={hostRef}>
        <li className={styles.title}>You selected</li>
        {Object.keys(answers).map((group) => Object.keys(answers[group]).map((key) => {
            if(questions[group][key].shorthand) {
                if(answers[group][key] instanceof Array)
                    return (
                        <>
                            {answers[group][key].map((answer) => (
                                <li className={styles[group]} key={`${group}${key}${answer}`}>
                                    {answer}
                                    {' '}
                                    {questions[group][key].shorthand}
                                </li>
                            ))}
                        </>
                    );

                return (
                    <li className={styles[group]} key={`${group}${key}`}>
                        {answers[group][key]}
                        {' '}
                        {questions[group][key].shorthand}
                    </li>
                );
            }

            if(answers[group][key] instanceof Array)
                return (
                    <Fragment key={`${group}${key}`}>
                        {answers[group][key].map((answer) => (
                            <li className={styles[group]} key={`${group}${key}${answer}`}>{answer}</li>
                        ))}
                    </Fragment>
                );

            return (<li className={styles[group]} key={`${group}${key}`}>{answers[group][key]}</li>);
        }))}
    </ul>
);

Selections.propTypes = {
    answers: PropTypes.objectOf(
        PropTypes.objectOf(
            PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
        ),
    ).isRequired,
    questions: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    ).isRequired,
    hostRef: PropTypes.func.isRequired,
};

const easeIn = [0.4, 0.0, 1, 1];
const easeOut = [0.0, 0.0, 0.2, 1];

export default posed(Selections)({
    preEnter: {
        y: 50,
        opacity: 0,
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 400,
            ease: easeOut,
        },
    },
    exit: {
        y: 50,
        opacity: 0,
        transition: {
            duration: 400,
            ease: easeIn,
        },
    },
});
